import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FileForm } from './file-form';

export class CompanyVendorFileForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyVendorId: FormControl<number | undefined>;
  VendorId: FormControl<number | null>;
  ExemptVendorId: FormControl<number | null>;
  ClientRegisteredVendorId: FormControl<number | null>;
  CompanyId: FormControl<number | undefined>;
  FileId: FormControl<number | undefined>;
  createdBy: FormControl<number | null>;
  updatedBy: FormControl<number | null>;
  docType: FormControl<string | undefined>;
  permission: FormControl<
    | 'ALL'
    | 'ADMIN'
    | 'VENDOR'
    | 'CLIENT'
    | 'CLIENT_ADMIN'
    | 'VENDOR_ADMIN'
    | null
  >;
  isArchived: FormControl<boolean>;

  File: FileForm;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      CompanyVendorId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      VendorId: new FormControl<number | null>(null),
      ExemptVendorId: new FormControl<number | null>(null),
      ClientRegisteredVendorId: new FormControl<number | null>(null),
      CompanyId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      FileId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      createdBy: new FormControl<number | null>(null, { nonNullable: true }),
      updatedBy: new FormControl<number | null>(null, { nonNullable: true }),
      docType: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      permission: new FormControl<
        | 'ALL'
        | 'ADMIN'
        | 'VENDOR'
        | 'CLIENT'
        | 'CLIENT_ADMIN'
        | 'VENDOR_ADMIN'
        | null
      >(null),
      isArchived: new FormControl<boolean>(false, { nonNullable: true }),

      File: new FileForm()
    });
  }
}

/*

File?: File;
User?: User;
*/
